import script from "./my-upload-img.vue?vue&type=script&setup=true&lang=js"
export * from "./my-upload-img.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__